import React from 'react';
import { Route, Switch } from 'react-router';

import NotFound404 from '../components/NotFound404';
import AuthenticatorHOC from '../containers/Authenticator';
import HomePage from '../components/HomePage';
import IndividualVCFeedPage from '../containers/IndividualVCFeedPage';

const AuthenticatedHomePage = AuthenticatorHOC(HomePage);
const AuthIndividualVCFeedPage = AuthenticatorHOC(IndividualVCFeedPage);

const Routes = () => (
  <Switch>
    <Route
      exact
      path="/forget-password"
      component={AuthenticatedHomePage}
    />
    <Route
      exact
      path="/individual-feed/:vcId"
      component={AuthIndividualVCFeedPage}
    />
    <Route
      exact
      path="/not-found-404"
      component={NotFound404}
    />
    <Route
      path="/"
      component={AuthenticatedHomePage}
    />

  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/index.js